export default class Menu {
  constructor() {
    this.toggleBtn = document.querySelector('.header__hamburger');
    this.header = document.querySelector('.header');

    this.lastScrollTop = 0;

    this.init();
  }

  init() {
    if (this.toggleBtn && this.header) {
      this.toggleBtn.addEventListener('click', (e) => this.handleToggleMenu(e));
    }

    if (this.header) {
      // listen for scroll updates
      window.addEventListener('scroll', () => this.handleScrollWindow());
    }
  }

  handleToggleMenu(e) {
    e.preventDefault();
    this.header.classList.toggle('open');
  }

  handleScrollWindow() {
    const scrollPos = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollPos > this.lastScrollTop) {
      this.header.classList.add('header--scroll');
    } else {
      this.header.classList.remove('header--scroll');
    }

    this.lastScrollTop = scrollPos <= 0 ? 0 : scrollPos;
  }
}
